import { useNavigate } from "react-router-dom";
import "./Css/ExamCreateForm.css";
import { useEffect, useState } from "react";
import { useRef } from "react";
import axios from "axios";
import API_BASE from "../config/api";

const InstitudeForm = () => {
  const navigate = useNavigate();

  const [softwares, setSoftwares] = useState([]);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);
  const [showSoftwareDropdown, setShowSoftwareDropdown] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [credentials, setCredentials] = useState(null);

  const [formData, setFormData] = useState({
    instituteName: "",
    principleName: "",
    address: "",
    email: "",
    phoneNumber: "",
    commissionPercentage: "",
    softwares: []
  });

  /* -------------------- Load Software Dropdown -------------------- */
  useEffect(() => {
    axios
      .get(`${API_BASE}/api/Institutes/dropdown`)
      .then(res => setSoftwares(res.data))
      .catch(err => console.error("Dropdown error", err));
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowSoftwareDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  /* -------------------- Handlers -------------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSoftwareChange = (e) => {
    const selectedIds = Array.from(e.target.selectedOptions).map(
      option => Number(option.value)
    );

    setFormData(prev => ({ ...prev, softwareIds: selectedIds }));
  };

  const handleSoftwareCheckboxChange = (software) => {
    setFormData(prev => {
      const exists = prev.softwares.find(x => x.softwareId === software.id);

      if (exists) {
        return {
          ...prev,
          softwares: prev.softwares.filter(x => x.softwareId !== software.id)
        };
      }

      return {
        ...prev,
        softwares: [
          ...prev.softwares,
          {
            softwareId: software.id,
            subscriptionType: 1, // default Basic
            duration: 1, // default Monthly
            purchasedPrice: software.softwarePrice,
            startDate: new Date().toISOString().split("T")[0]
          }
        ]
      };
    });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const res = await axios.post(`${API_BASE}/api/Institutes`, {
        instituteName: formData.instituteName,
        principleName: formData.principleName,
        address: formData.address,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        commissionPercentage: Number(formData.commissionPercentage),
        softwares: formData.softwares
      });

      setCredentials(res.data);
      setShowPopup(true); // ✅ popup will render
    } catch (err) {
      alert(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Password copied!");
  };

  /* -------------------- UI -------------------- */
  return (
    <div className="create-exam-wrapper">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          संस्था व्यवस्थापन &gt;&gt; <span>नवीन संस्था जोडा</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button className="btn primaryy" onClick={handleSubmit} disabled={loading}>
            {loading ? "सेव्ह होत आहे..." : "सेव्ह करा"}
          </button>
        </div>
      </div>

      {/* Form */}
      <div className="create-exam-form">
        <h2>नवीन संस्था जोडा</h2>

        <div className="form-grid">
          <div className="form-group">
            <label>संस्था नाव</label>
            <input
              type="text"
              name="instituteName"
              value={formData.instituteName}
              onChange={handleChange}
              placeholder="संस्थेचे नाव इथे टाका"
            />
          </div>

          <div className="form-group">
            <label>मुख्याधापक नाव</label>
            <input
              type="text"
              name="principleName"
              value={formData.principleName}
              onChange={handleChange}
              placeholder="मुख्याधापक नाव इथे टाका"
            />
          </div>

          <div className="form-group">
            <label>पत्ता</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="पत्ता इथे टाका"
            />
          </div>

          <div className="form-group">
            <label>ईमेल</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="ईमेल इथे टाका"
            />
          </div>

          <div className="form-group">
            <label>मोबाइल नंबर</label>
            <input
              type="number"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              placeholder="मोबाइल नंबर इथे टाका"
            />
          </div>

          <div className="form-group">
            <label>कमिशन टक्केवारी</label>
            <input
              type="text"
              name="commissionPercentage"
              value={formData.commissionPercentage}
              onChange={handleChange}
              placeholder="कमिशन टक्केवारी इथे टाका"
            />
          </div>

          {/* MULTI SOFTWARE SELECT */}
          <div className="form-group" ref={dropdownRef}>
            <label>परीक्षेचे नाव</label>

            {/* Dropdown header */}
            <div
              className="dropdown-select"
              onClick={() => setShowSoftwareDropdown(prev => !prev)}
            >
              <span>
                {formData.softwares.length > 0
                  ? `${formData.softwares.length} निवडले`
                  : "परीक्षेचे नाव निवडा"}
              </span>
              <span className="dropdown-arrow">▾</span>
            </div>

            {/* Dropdown options (absolute overlay) */}
            {showSoftwareDropdown && (
              <div className="dropdown-options">
                {softwares.map(sw => (
                  <label key={sw.id} className="dropdown-option">
                    <input
                      type="checkbox"
                      checked={formData.softwares.some(x => x.softwareId === sw.id)}
                      onChange={() => handleSoftwareCheckboxChange(sw)}
                    />
                    {sw.softwareName}
                  </label>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {showPopup && credentials && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>संस्था यशस्वीरित्या तयार झाली</h3>

            <div className="popup-content">
              <p>
                <strong>Institute ID:</strong><br />
                {credentials.instituteUniqueId}
              </p>

              <p>
                <strong>Username:</strong><br />
                {credentials.username}
              </p>

              <p>
                <strong>Password:</strong><br />
                <span className="password-text">{credentials.password}</span>
                <button
                  className="btn outlinee"
                  style={{ marginLeft: "10px" }}
                  onClick={() => copyToClipboard(credentials.password)}
                >
                  Copy
                </button>
              </p>
            </div>

            <div className="popup-actions">
              <button
                className="btn primaryy"
                onClick={() => {
                  setShowPopup(false);
                  navigate("/dashboard/institudemng");
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Selected Software Purchase Details */}
      {formData.softwares.map((sw, index) => {
        const softwareInfo = softwares.find(s => s.id === sw.softwareId);

        return (
          <div key={sw.softwareId} className="create-exam-form" style={{ marginTop: "20px" }}>
            <h3>{softwareInfo?.softwareName} - खरेदी तपशील</h3>

            <div className="form-grid">

              <div className="form-group">
                <label>सदस्यता प्रकार</label>
                <select
                  value={sw.subscriptionType}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setFormData(prev => {
                      const updated = [...prev.softwares];
                      updated[index].subscriptionType = value;
                      return { ...prev, softwares: updated };
                    });
                  }}
                >
                  <option value={1}>Basic</option>
                  <option value={2}>Standard</option>
                  <option value={3}>Premium</option>
                </select>
              </div>

              <div className="form-group">
                <label>कालावधी</label>
                <select
                  value={sw.duration}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setFormData(prev => {
                      const updated = [...prev.softwares];
                      updated[index].duration = value;
                      return { ...prev, softwares: updated };
                    });
                  }}
                >
                  <option value={1}>मासिक</option>
                  <option value={2}>वार्षिक</option>
                </select>
              </div>

              <div className="form-group">
                <label>खरेदी किंमत</label>
                <input
                  type="number"
                  value={sw.purchasedPrice}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setFormData(prev => {
                      const updated = [...prev.softwares];
                      updated[index].purchasedPrice = value;
                      return { ...prev, softwares: updated };
                    });
                  }}
                />
              </div>

              <div className="form-group">
                <label>खरेदी तारीख</label>
                <input
                  type="date"
                  value={sw.startDate}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData(prev => {
                      const updated = [...prev.softwares];
                      updated[index].startDate = value;
                      return { ...prev, softwares: updated };
                    });
                  }}
                />
              </div>

            </div>
          </div>
        );
      })}
    </div>
  );
};

export default InstitudeForm;
